<template>
	<div class="flex gap-16px" :class="{ 'flex-col mdp:flex-row': !isPhLayoutA }">
		<template v-for="item in itemList">
			<SocialIconButton
				v-if="item.isShow"
				:icon="item.icon"
				:text="item.text"
				:tagText="tagText"
				:key="item.icon"
				:isShowTag="item.icon === tagType"
				:isPhLayoutA="isPhLayoutA"
				@onClick="handleClick(item.icon)"
			></SocialIconButton>
		</template>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import SocialIconButton from '@/components/SocialIconButton.vue'
import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'
import { getCurrentGaPageName } from '@/lib/utils'

const props = defineProps({
	isShowGoogle: {
		type: Boolean,
		default: false,
	},
	isShowFacebook: {
		type: Boolean,
		default: false,
	},
	isShowApple: {
		type: Boolean,
		default: false,
	},
	tagText: {
		type: String,
		default: '',
	},
	tagType: {
		type: String,
		default: '',
	},
	isPhLayoutA: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['signInGoogle', 'signInFacebook', 'signInApple'])

const itemList = computed<
	{
		isShow: boolean
		icon: 'google' | 'facebook' | 'apple'
		text: string
	}[]
>(() => [
	{
		isShow: props.isShowGoogle,
		icon: 'google',
		text: 'Google',
	},
	{
		isShow: props.isShowFacebook,
		icon: 'facebook',
		text: 'Facebook',
	},
	{
		isShow: props.isShowApple,
		icon: 'apple',
		text: 'Apple',
	},
])

const handleClick = (icon: string) => {
	const buttonName = props.isPhLayoutA ? 'SSO Click - Hero' : 'SSO Click'
	createGAEvent(GaGeneralEvent.ButtonClick, {
		...(getCurrentGaPageName() && { page_name: getCurrentGaPageName() }),
		button_name: buttonName,
	})

	if (props.isPhLayoutA) {
		createGAEvent(GaGeneralEvent.LoginSignupStart, {
			...(getCurrentGaPageName() && { page_name: getCurrentGaPageName() }),
			event_extra: 'SSO - Hero',
		})
	}
	if (icon === 'google') {
		emit('signInGoogle')
	}
	if (icon === 'facebook') {
		emit('signInFacebook')
	}
	if (icon === 'apple') {
		emit('signInApple')
	}
}
</script>
